


styles += """
  .iframe_callout {
    font-size: 34px;
    font-weight: 700;
    padding-bottom: 32px;
    color: white;
    font-family: 'Fira Sans Condensed';
  }

"""

window.Tour = ReactiveComponent
  displayName: 'Tour'

  render: -> 
    use_iframe = WINDOW_WIDTH() > 900

    DIV null,          

      DIV 
        style: 
          textAlign: 'center'
          paddingTop: 40        
          position: 'relative'
          zIndex: 1
          top: 8

        if !use_iframe
          # Demo
          #   width: Math.min 1050, SAAS_PAGE_WIDTH()
          #   src: 'death_star_example.png' # 'overall_mozilla-small-x264.mp4'
          #   href: 'https://galacticfederation.consider.it'

          DIV 
            style: 
              width: "min(1050px, var(--SAAS_PAGE_WIDTH))"
              margin: 'auto'
            Webframe
              href: demo_url()
              width: "100%"

              DIV 
                style: 
                  width: '100%'
                  margin: 'auto'
                  position: 'relative'

                IMG
                  loading: "lazy"
                  src: asset('product_page/death_star_example.png')
                  alt: "Consider.it visually summarizes what people think (on a spectrum) and why (through pros and cons)."
                  style:
                    aspectRatio: '1716/1112'
                    width: '100%'
                    paddingTop: 10
                    display: 'block'

        else 
          local = location.origin.indexOf('localhost') > -1
          embedded_host = if local then location.origin else "#{location.protocol}//galacticfederation.#{location.host}"
          src = "#{embedded_host}/1-billion-rcs-to-fight-ewok-flu-investment-we-must-make-before-the-council?embedded_demo=true#{if local then '&domain=galacticfederation' else ''}"


          DIV null,


            if use_iframe
              DIV 
                className: 'condensed main_callout' # 'iframe_callout'
                # style: 
                #   fontSize: 44
                "Learn by doing: weigh in on these joke proposals!"


            DIV 
              style: 
                fontSize: 18
                color: 'white'
                marginBottom: 48
                textAlign: if !use_iframe then 'right'

              if use_iframe

                "...or access the "
              else 
                "Access the"
              A
                href: demo_url()
                target: "_blank"
                "full parody forum"
              "."

            DIV 
              style: 
                margin: 'auto'
                width: "min(1502px, 97vw)"
              Webframe
                browser_loc: demo_url()
                width: '100%'

                IFRAME 
                  ref: 'iframe'
                  src: src
                  width: '100%'
                  
                  style: 
                    backgroundColor: 'white'
                    aspectRatio: "6 / 3"
                    height: '100%'
                    width: '100%'



      DIV 
        style: 
          position: 'relative'
          zIndex: 2
          backgroundColor: 'white'
          boxShadow: '0px -17px 27px 0px rgba(0,0,0,.14)'
          paddingTop: 42


        H1
          className: "bold_callout"
          style:
            fontWeight: 600

          """
          The only forum to visually summarize 
          """

          if WINDOW_WIDTH() > 1000
            BR null
          """
          what your community thinks and why
          """

        # TestimonialBlockquote
        #   testimonial: testimonials.pierre

        TestimonialGrid 
          testimonials: [testimonials.pierre, testimonials.auryn, testimonials.daniel]


        Basics()


        # TestimonialBlockquote
        #   testimonial: testimonials.auryn_bold

        DIV 
          style: 
            maxWidth: 660
            fontSize: 16
            margin: '56px auto 48px auto'
            textAlign: 'center'
            padding: '0 24px'

          DIV
            className: 'light_callout'

            "Want to get started now?"

          "It only takes a minute to create a forum! Or learn more about features, below."



        ConversionAttempt
          backgroundColor: "#9816e2"


        Features
          features: all_features

        
        BonusFeatures
          features: bonus_features

        ConversionAttempt
          backgroundColor: "#734487" # "rgb(253, 121, 4)"
          pages: ["create_forum", "contact"]

        CompareToOtherTools()

        Research()   

        # ConversionAttempt
        #   backgroundColor: "rgb(253, 121, 4)"
        #   pages: ["create_forum", "contact"]

  setiframeconsole: ->
    iframeWindow = @refs.iframe?.contentWindow
    if iframeWindow
      iframeWindow.console.log = (val) ->
        console.log "iframe: ", val

  componentDidMount: -> 
    @setiframeconsole()
  componentDidUpdate: ->
    @setiframeconsole()

steps = [
  {
    header: 'Create and tailor your forum'
    alt: 'Starting and configuring your Consider.it forum only takes a few minutes.'
    desc: [
      """
      Easily create a new forum. Then make it your own by explaining the forum's purpose, adding 
      a logo, setting an evocative background image, or enabling language translation.
      """

      """
      You can also configure sign-up questions to help you collect relevant data from 
      your participants (in the Premium Plan). 
      """

    ]

    movie: 'tour1-framing-small-x264'
    browser_loc: 'https://denverclimateaction.consider.it'
  }
  {
    header: 'Frame the dialogue & invite participation'
    alt: 'Invite engagement by asking relevant open-ended questions or proposing solutions to problems your community cares about.'    
    desc: [

      # """
      # Consider.it can create a transparent account of your community’s opinions about the 
      # issues and opportunities confronting it. 
      # """

      # """
      # Consider.it creates a transparent account of your community’s opinions. 
      # """

      """
      You can ask open-ended questions to foster community ideation, or just request 
      feedback on specific proposals. Uses include collaborative prioritization, goal setting, 
      policy feedback, and evaluating strategic direction.
      """      

      """
      After you've framed the dialogue, invite participation through social media, mailing lists,
      and other engagement channels.
      """      

    ]
    movie: 'tour2-seeding-small-x264'
    browser_loc: 'https://denverclimateaction.consider.it'
  }

  {

    header: 'Participants engage'
    alt: "Consider.it can create a transparent account of your community’s opinions about the issues and opportunities confronting it."
    desc: [
      """

      Participants share their overall opinion about proposals 
      on a spectrum, using a slider. They are also guided to express their underlying 
      reasoning, as points in a pro & con list. 
      They can incorporate the pros and cons others have already shared into their own list. 
      This helps show which reasons resonate most.   
      """

      # """      
      # In Consider.it, participants can share their overall opinion about a proposal 
      # on a spectrum. They are also guided to express their underlying pro & con 
      # reasoning. They can build from the pros and cons others have already contributed. 
      # """

      """
      Your community learns from each other. Important tradeoffs are identified. 
      Personal attacks don’t make sense in the pro/con format. 
      """

    ]
    movie: 'trimmed-tour3-participation-small-x264'
    browser_loc: 'https://denverclimateaction.consider.it'
  }


  {

    header: 'Explore patterns of thought in your community'
    alt: "Consider.it gives you data that is like a hybrid between a survey and a focus group."
    # header: 'Slice & dice opinions for deep understanding'
    desc: [
      """
      Consider.it provides a dynamically updating, interactive summary of what your 
      community thinks and why. Use it to learn more about your community!
      """

      """
      For example, you can easily learn the reservations of those who oppose a proposal. 
      Perhaps 80% of those who oppose share a concern that can be resolved to 
      clear the path forward. 
      """

    ]
    movie: 'tour4-analyze-small-x264'
    browser_loc: 'https://denverclimateaction.consider.it'
  }

]


styles += """
  [data-widget="Basics"] {
    margin: auto;
    padding: 60px 0px 0px 0px;
  }

  [data-widget="Basics"] .step {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 96px 12px 96px 12px;
    position: relative;
    margin: auto;
  }

  @media (max-width: 700px) {
    [data-widget="Basics"] .step {
      padding: 48px 12px 48px 12px;
    }
  }


  [data-widget="Basics"] .step.even {
    background-color: #f5f7fa;
  }

  .custom-shape-divider-top-1652629163 {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    overflow: hidden;
    line-height: 0;
  }

  .custom-shape-divider-top-1652629163 svg {
    position: relative;
    display: block;
    width: 100%;
    height: 43px;
  }

  [data-widget="Basics"] .step.odd .custom-shape-divider-top-1652629163 .shape-fill {
    fill: #f5f7fa;
  }  

  .custom-shape-divider-top-1652629163 .shape-fill {  
    fill: #fff;
  }

  [data-widget="Basics"] .step.even .text {
    margin-right: 64px;
  }

  [data-widget="Basics"] .step.odd .text {
    margin-right: 64px;
  }




  [data-widget="Basics"] .text {
    max-width: 420px;
    /* min-width: 350px; */
    position: relative;
  }

  @media (max-width: 1050px) {
    [data-widget="Basics"] .step {
      flex-direction: column;
    }
    [data-widget="Basics"] .step.odd .text, [data-widget="Basics"] .step.even .text {
      margin: 0;
      max-width: 650px;
      margin-bottom: 24px;
    }

  }


  [data-widget="Basics"] .text h2 .numbered {
    padding-right: 18px;
  }


  @media (max-width: 810px) {
    [data-widget="Basics"] .text h2 .numbered {
    }
  }

  @media (min-width: 811px) and (max-width: 1549px) {
    [data-widget="Basics"] .text h2 .numbered {
      left: -32px;
      position: absolute;

    }

  }

  @media (min-width: 1550px) {
    [data-widget="Basics"] .text h2 .numbered {
      position: absolute;
      font-size: 150px;
      font-family: 'Fira Sans Condensed';
      font-weight: 400;
      color: #c3d5e6;
      left: -180px;
    }
  }


  [data-widget="Basics"] .visual {
    width: min(650px, var(--SAAS_PAGE_WIDTH));
  }

  @media (min-width: 1050px) and (max-width: 1200px){
    [data-widget="Basics"] .visual {
      width: 550px;
    }
  }


  [data-widget="Basics"] .text h2 {
    padding-bottom: 16px;
    font-weight: 700;
    font-size: 24px;
    color: #333;
  }

  [data-widget="Basics"] .description {

  }
  [data-widget="Basics"] .description p {
    font-size: 15px;
    color: #333;    
    padding-bottom: 16px;
  }

  [data-widget="Basics"] .video_container {
    width: 100%;
    margin: auto;
    position: relative;
    background-color: black;
  }
  [data-widget="Basics"] video {
    width: 100%;
    margin: auto;
    position: relative;
    display: block;
  }
"""


Basics = ReactiveComponent
  displayName: 'Basics'

  render: ->    

    play_video = => 
      e = => 
        @local.playing = false
        @local.finished = true
        save @local
        @refs.video.removeEventListener 'ended', e

      @refs.video.play()
      @refs.video.addEventListener 'ended', e

      @local.playing = true
      @local.hovering = true 
      @local.finished = false
      save @local

    DIV null,
        
      A 
        name: 'basics'


      DIV 
        style: 
          maxWidth: 820
          margin: '48px auto 36px auto'
          textAlign: 'center'

        H2
          className: 'light_callout'

          # "Are you imagining your own forum yet?"
          "Have you started to imagine hosting a forum?"

        "If you decide to host a forum, these are the common stages you'll experience."

          # 'Imagining your Consider.it forum'




      for step, idx in steps
        desc =  DIV 
            key: 'desc'
            className: "text"
            H2 null,
              SPAN 
                className: "numbered"

                "#{idx + 1}."
              step.header


            DIV 
              className: 'description'
              for para in step.desc
                P 
                  key: para
                  para

        visual = DIV 
            key: 'visual'
            className: "visual"

            Webframe 
              browser_loc: step.browser_loc
              width: "100%"
              dummy: @local.hovering
              dummy2: @local.current_step
              dummy3: @local.playing
              key: @local.current_step

              DIV 
                className: 'video_container'

                VIDEO 
                  loading: "lazy"          
                  key: @local.current_step
                  ref: 'video'
                  preload: 'true'
                  loop: true
                  autoPlay: true
                  controls: true
                  muted: true
                  title: step.alt
                  style:
                    aspectRatio: "21/9"
                  onKeyPress: (e) => 
                    if e.which == 32 || e.which == 13
                      if @local.hovering
                        inactivate()
                      else 
                        activate()

                  SOURCE
                    src: asset("product_page/screencasts/#{step.movie}.mp4")
                    type: "video/mp4"

                  step.alt or "Your browser does not support the video element."

        DIV
          key: idx 
          className: "step #{if idx % 2 then 'odd' else 'even'}"

          DIV 
            dangerouslySetInnerHTML: __html: """

              <div class="custom-shape-divider-top-1652629163">
                  <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                      <path d="M649.97 0L550.03 0 599.91 54.12 649.97 0z" class="shape-fill"></path>
                  </svg>
              </div>
            """
          
          [desc, visual]

  componentDidMount: ->
    play_videos_when_in_viewport ReactDOM.findDOMNode(@), {play_only_topmost_video: true}
  componentDidUpdate: ->
    play_videos_when_in_viewport ReactDOM.findDOMNode(@), {play_only_topmost_video: true}



styles += """
  [data-widget="Features"] {
    background-image: linear-gradient(180deg, #8800FF 0%, #FF7900 100%);    
    color: white;
    position: relative;
    padding-top: 0px;
    padding-bottom: 140px;
    /* top: -80px; */
  }

  [data-widget="Features"] .features {
    display: flex;
    width: 100%;
    padding: 250px 0px 100px 0px;
    flex-wrap: wrap;
    justify-content: center;
  }

"""


Features = ReactiveComponent
  displayName: 'Features'

  render: -> 
    DIV null,
      A 
        name: 'features'

      DIV
        dangerouslySetInnerHTML: __html: """

          <style> 
            .custom-shape-divider-top-1652638490 {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                overflow: hidden;
                line-height: 0;
            }

            .custom-shape-divider-top-1652638490 svg {
                position: relative;
                display: block;
                width: 100%;
                top: -1px;
            }

            .custom-shape-divider-top-1652638490 .shape-fill {
                fill: #FFFFFF;
            }

            [data-widget="Features"] div.features {
              padding-top: #{250 * WINDOW_WIDTH() / 1700}px;
            }


          </style>
          <div class="custom-shape-divider-top-1652638490">
              <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 180" preserveAspectRatio="none">
                  <path id="curve2" d="M 0 0 Q 600 300 1200 0 M 1200 0 V 0 H 0 V 0" class="shape-fill"/>
                  <text style="font-size: 72px; font-weight: 800; fill: #9816e2; text-transform: uppercase;" text-anchor="middle" x="51%" dy="2">
                    <textPath xlink:href="#curve2">Features</textPath>
                  </text>
              
              </svg>
          </div>

        """          


      # DIV 
      #   style: 
      #     float: 'right'
      #     marginRight: 140

      #   TestimonialGrid
      #     testimonials: [testimonials.auryn_bold]
      #     top: false
      #     left: false
      #     maxWidth: 650

      DIV 
        className: 'features'
        style: 
          width: '100%'

        for feature in @props.features

          Feature 
            key: feature.label
            feature: feature 


      DIV
        dangerouslySetInnerHTML: __html: """
          <style>
            .custom-shape-divider-bottom-1649436271 {
                position: absolute;
                bottom: 0;
                left: 0;
                width: 100%;
                overflow: hidden;
                line-height: 0;
            }

            .custom-shape-divider-bottom-1649436271 svg {
                position: relative;
                display: block;
                width: 100%;
            }

            .custom-shape-divider-bottom-1649436271 .shape-fill {
                fill: #FFFFFF;
            }
          </style>
          <div class="custom-shape-divider-bottom-1649436271">
              <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 160" preserveAspectRatio="none">
                  <path d="M 0 0 Q 600 299 1200 0 M 1200 0 v 160 H 0 V 0" class="shape-fill"></path>
              </svg>
          </div>
        """     

  componentDidMount: ->
    play_videos_when_in_viewport ReactDOM.findDOMNode(@)
  componentDidUpdate: ->
    play_videos_when_in_viewport ReactDOM.findDOMNode(@)


styles += """
  [data-widget="Feature"] {
    position: relative;
    /* min-width: 496px; */
    max-width: 550px;
    padding: 36px 24px;
  }

  [data-widget="Feature"] h3 {
    font-weight: 800;
    font-size: 24px;
    text-align: center;
    margin-bottom: 16px;
    color: white;
    text-transform: capitalize;
  }

  @media (max-width: 700px) {
    [data-widget="Feature"] h3 {
      font-size: 20px;
    }
  }


  [data-widget="Feature"] .paid_forum {
    margin-left: 8px;
    background-color: #{upgrade_color};
    font-size: 12px;
    padding: 4px 6px;
    text-transform: lowercase;
    color: white;
    border-radius: 8px;
    vertical-align: middle;
  }

  [data-widget="Feature"] .description {
    font-weight: 500;
    font-size: 16px;
    margin-bottom: 16px;
    min-height: 70px;
  }
"""

Feature = ReactiveComponent
  displayName: 'Feature'

  render: -> 
    feature = @props.feature

    has_media = !!feature.img || !!feature.video

    activate = => 
      @local.hovering = true 
      save @local 
    inactivate = => 
      @local.hovering = false 
      save @local 


    DIV 
      'data-id': feature.id    

      A name: feature.id


      H3 null,

        feature.label

        if feature.paid
          SPAN
            className: 'paid_forum'
            'paid'


      DIV 
        className: 'description embedded'
        dangerouslySetInnerHTML: {__html: feature.html}


      if has_media
        boxShadow = if !feature.testimonial
                      '0 1px 4px rgba(0,0,0,.25)' 
                    else 
                      null
        DIV 
          style:  
            verticalAlign: 'top'
            lineHeight: 0
            margin: '8px auto 20px auto'

          if feature.img 
            is_gif = feature.img.indexOf('.gif') > -1
            sty = 
              width: '100%'
              backgroundColor: 'white'
              transition: if is_gif then 'opacity 500ms'
              boxShadow: boxShadow
              transition: 'box-shadow 500ms'

            IMG 
              loading: "lazy"            
              src: feature.img 
              style: sty
              alt: feature.alt

          else if feature.video

            VIDEO
              loading: "lazy"            
              ref: 'video'
              preload: 'true'
              loop: true
              autoPlay: true
              muted: true
              controls: true
              title: feature.alt
              style: 
                position: 'relative'
                width: '100%'
                # width: Math.min(SAAS_PAGE_WIDTH() - 80, 800, @local.video_height * 1920/1080)
                aspectRatio: '1920/1080'
                # height: Math.min(1080/1920 * (SAAS_PAGE_WIDTH() - 80), 800 * 1080/1920, @local.video_height or 0)
                boxShadow: boxShadow
                transition: 'box-shadow 500ms'
                display: 'block'

              SOURCE
                key: 'mp4'
                src: feature.video
                type: "video/mp4"

              feature.alt or "Your browser does not support the video element."



  componentDidMount: -> 
    if @refs.video && !@local.video_height?
      @local.video_height = @refs.video.parentNode.offsetWidth * 1080/1920





all_features = [

 {
  id: 'ideas'    
  label: 'Idea generation'
  html: """
        Pose open-ended questions to your community, and learn from them! 
        See which ideas gain traction.
        """
  video: asset('product_page/screencasts/ideation-x264.mp4')
  paid: false
  alt: "In Consider.it, you can enable community ideation by asking open-ended questions like \"What are your most important questions?\"."
 }


 {
  id: 'profile_questions'  
  label: 'Sign-up questions'
  html: """
        Collect relevant information from participants (e.g. demographics). This data 
        can be used for comparing opinions between subgroups. 
        """

  video: asset('product_page/profile_questions.mp4')
  paid: true
  alt: "Sign-up questions can help you understand who your participants are."  
 }

 {
  id: 'opinion_analytics'    
  label: 'Opinion analytics'
  # html: 'You may wish to filter opinions based upon user characteristics or some other differentiator. For example, you might want to learn what Board Members think of a proposal. Or perhaps you want to learn what renters think of a planning proposal, filtering out homeowners. We can configure your forum so you can understand what different stakeholder segments think and why.'
  html: """
        Slice and dice the data to learn what different subgroups think! Can draw on 
        data from sign-up questions. 
        """
  video: asset('product_page/screencasts/trimmed-opinion_analytics-small-x264.mp4')
  paid: false
  alt: "In Consider.it, you can examine similarities and differences of opinions between subgroups."  
 }


 {
  id: 'tab_organization'  
  label: 'Multi-page forums'
  html: """
        Structure your forum by separating your topics into different pages. 
        You can even create an About page. 
        """

  video: asset('product_page/screencasts/tabs-small-x264.mp4')
  paid: true
  alt: "When you have lots of questions to ask of your community, you can break them into different tabs to help organize them."
 }


 {
  id: 'private_forums'    
  label: 'Private forums'
  html: """
        Your forum can be set to private so that only people who have been invited can access the dialogue.
        """
  img: asset('product_page/private_forum_new.png')
  alt: "Private forums allow for sensitive conversations to be accessed only be the relevant parties."

 }


 {
  id: 'anonymization'    
  label: 'Anonymization'
  html: """
        Sometimes names can distort participation. Enable anonymous mode to hide names.
        """
  video: asset('product_page/screencasts/anonymization-x264.mp4')
  paid: false
  alt: "Anonymous mode can help conversations get going when power dynamics are at play."  
 }




 {
  id: 'translation'    
  label: 'Language translation'
  html: """
        Google Translate can be featured prominently for multi-lingual forums. We also offer interface translations for a number of languages.
        """
  img: asset('product_page/translation.gif')
  paid: false
  alt: "Language translation in forums is hard to do, but we have options for you."  
 }

 {
  id: 'data_export'    
  label: 'Data export'
  html: """
        Export data to CSV for record keeping, or for analysis in an external system. 
        We can work with you if you have other data requirements.         
        """
  img: asset('product_page/data_export_new.png')
  paid: true
  alt: "The data export feature is easy to use."  
 }

 {
  id: 'moderation'    
  label: 'Comment moderation'
  html: """
        Choose an appropriate moderation policy. Explicit moderation is often 
        unnecessary as <a href="#research">Consider.it can itself help create more civil discourse</a>.
        """
  video: asset('product_page/screencasts/moderation-small-x264.mp4')
  paid: false
  alt: "Moderation is a great way to feel the pulse of your engagement."  
 }

]  



bonus_features = [

 {
  id: 'accessibility'  
  label: 'Disability accessibility'
  html: """
        Consider.it is <strong>Level A compliant</strong> with the <a href="https://www.w3.org/WAI/intro/wcag.php" target="_blank" style="text-decoration: underline;">Web Content Accessibility Guidelines (WCAG)</a>. See our <a target="_blank" href="https://docs.google.com/document/d/e/2PACX-1vS5-8UQlzGYY5Su38VDUXDbiAy2S72ZARfU8-Xmi-Nxo5vvXN9HkV_W6zXYF6o-2UM5cHuR4FvTdR1N/pub">Accessibility Statement</a>.</p>
        """
  # testimonial: testimonials.sheri 
 }
 {
  id: 'open_source'  
  label: 'Open Source Software'
  html: """
        Consider.it's initial design and development was funded by the <a target="_blank" href="https://cjmd.com.uw.edu/project-archives/nsf-grant-developing-technologies-for-public-engagement-and-deliberation/">National Science Foundation</a>. We honor our public support by keeping <a href="https://github.com/Considerit/ConsiderIt" target="_blank">our code </a> open source!
        """
 }


]


styles += """
  @media (max-width: 566px) {
    [data-widget="BonusFeatures"] [data-widget="BonusAttribute"]:last-child {
      display: none;
    }
  }
"""

BonusFeatures = ReactiveComponent
  displayName: 'BonusFeatures'

  render: -> 
    DIV 
      style: 
        margin: '80px 0'
      DIV 
        style: 
          width: '100%'
          display: 'flex'
          justifyContent: 'center'
          marginTop: -230


        for feature, idx in @props.features
          BonusAttribute 
            key: feature.label
            feature: feature 

      DIV 
        style: 
          paddingTop: 20

        TestimonialBlockquote
          testimonial: testimonials.sheri


styles += """
  [data-widget="BonusAttribute"] {
    position: relative;
    width: 496px;
  }

  [data-widget="BonusAttribute"] .tag {
    padding: 36px 46px;
    margin: 0 24px;
    background: #FFFFFF;
    box-shadow: 0 2px 4px 0 rgba(0,0,0,0.26);    
  }

  [data-widget="BonusAttribute"] h3 {
    font-weight: 600;
    font-size: 22px;
    text-align: center;
    margin-bottom: 16px;
    text-transform: capitalize;
  }

  [data-widget="BonusAttribute"] .description {
    font-weight: 500;
    font-size: 15px;
    margin-bottom: 16px;
    min-height: 84px;
  }

  [data-widget="BonusAttribute"] .accessibility_to_testimony_connector {
    position: absolute;
    bottom: -26px;
    left: calc(50% - 20px);
  }
  @media (max-width: 768px) {
    [data-widget="BonusAttribute"] .accessibility_to_testimony_connector {
      display: none;
    }
  }
"""


BonusAttribute = ReactiveComponent
  displayName: 'BonusAttribute'

  render: -> 
    feature = @props.feature

    has_media = !!feature.img || !!feature.video || !!feature.testimonial


    DIV 
      className: 'feature'
      'data-id': feature.id    
      style: 
        #padding: 40
        position: 'relative'
        

      A name: feature.id

      if feature.id == 'accessibility'
        DIV 
          className: 'accessibility_to_testimony_connector'
          dangerouslySetInnerHTML: __html: """
            <svg width="40px" style="height:100%; filter: drop-shadow(0px 2px 1px hsla(0, 0%, 0%, 0.25));" viewBox="0 0 40 20">
                <polygon fill="white" points="0,0 20,20 40,0"></polygon>
            </svg>
          """

      DIV 
        className: 'tag'
        style: 
          paddingBottom: if feature.testimonial then 50
        if feature.label 
          H3 null,
            feature.label

        if feature.html 
          DIV 
            className: 'embedded description'

            dangerouslySetInnerHTML: {__html: feature.html}

      if feature.testimonial

        DIV 
          style: 
            marginTop: -70
            padding: '0 20px'

          TestimonialGrid
            testimonials: [testimonials.sheri]
            minWidth: "min( var(--SAAS_PAGE_WIDTH), 992px )"







# basic_features = [
#  {
#   id: 'opinion_slate'    
#   label: 'An Opinion Slate for your community'
#   html: 'Consider.it makes each stakeholder\'s opinion about whatever you\'re gathering feedback about visible. You\'ll get everyone on the same page quicker as a result.'
#   video: 'opinion_slate'  
#  }
#  {
#   id: 'proposals'    
#   label: 'Each proposal can be developed in detail'
#   html: 'Add as much detail to proposals as you wish, including embedding images or video. You control whether your community can post their own proposals.'
#   video: 'proposal_development'
#  }
#  {
#   id: 'slide_opinions'    
#   label: 'Express less partisan opinions with a sliding scale' #'See your opinion in relation to others'
#   html: 'Individuals slide their overall opinion about a proposal, integrating their opinion with others. The slider endpoints are configurable. You can set them to Agree/Disagree, High Priority/Low Priority or whatever your community is evaluating about a proposal.'
#   video: 'slide_it'   
#  }
#  {
#   id: 'pro_con_dialogue'    
#   label: 'Nuanced dialogue focuses on surfacing pros and cons'
#   html: 'Consider.it encourages stakeholders to think critically about the merits and disadvantages of an idea. In the margins, each participant can see the points of their peers, learn from them, and even include them in their own list of important points. Now your users are finding common ground with their peers!'
#   video: 'pro_con'
#  }
#  {
#   id: 'explore_opinions'    
#   label: 'Explore patterns of thought for deeper understanding'
#   html: 'Consider.it provides a dynamically updating, interactive summary of what your community thinks and why. You can drill deeper into the underlying reasoning of different groups. For example, learn the reservations of those who oppose a proposal. Perhaps 80% of those with reservations share two con points that can be resolved, helping build consensus!'
#   video: 'explore'
#  }
#  {
#   id: 'encourage_civility'    
#   label: 'Set focus and encourage civility'
#   html: 'Consider.it helps participants focus on the issue, rather than each other. Personal attacks don’t make sense in the Pro/Con format. Individuals can have extended discussions about single points, but they’re contained and don’t hijack the overall conversation.'
#   video: 'drilldown'
#  } 

#  {
#   id: 'accessibility'  
#   label: 'Accessible for people with disabilities'
#   html: 'Consider.it is <a href="https://www.w3.org/WAI/intro/wcag.php" target="_blank" style="text-decoration: underline;">WCAG</a> Level A compliant. Consider.it also provides a mechanism for users of screenreaders to ask for help. We help each of these folks individually to understand the proposals being discussed and input their opinions. Read our <a target="_blank" href="https://docs.google.com/document/d/e/2PACX-1vS5-8UQlzGYY5Su38VDUXDbiAy2S72ZARfU8-Xmi-Nxo5vvXN9HkV_W6zXYF6o-2UM5cHuR4FvTdR1N/pub">Accessibility Compliance Statement</a> for more information.'
#   testimonial: testimonials.sheri 
#  }

#  {
#   id: 'private_forums'    
#   label: 'Private Forums'
#   html: """<p>By default, your Consider.it forum is public. That means that anyone with a link can access your forum.</p>
#            <p>With Private Forums, you can lock down your forum to only those you invite via email.</p>"""
#  }

# ]



# paid_features = [
#  {
#   id: 'customization'
#   label: 'Customized Look, Feel, and Functionality'
#   html: 'We can work with you to design and implement a forum with the look and feel that you want for your brand. Moreover, we have a number of homepage templates that can organize your community’s ideas to best meet your needs.'
#   img: asset('product_page/customize_homepage.gif')
#  }

#  {
#   id: 'profile_questions'  
#   label: 'Ask demographic and profile questions'
#   html: 'You can ask for additional information from stakeholders when they create an account on your forum. For example, you can ask if they are a Donating Member of your organization. Or you can ask if they are a homeowner. Or you can ask demographic questions like age and race. This information is available in data exports. It can also be used in our opinion analytics described below.'
#   video: 'profile_questions'
#  }

#  {
#   id: 'opinion_analytics'    
#   label: 'Opinion Analytics for survey-like cross-tabs'
#   html: 'You may wish to filter opinions based upon user characteristics or some other differentiator. For example, you might want to learn what Board Members think of a proposal. Or perhaps you want to learn what renters think of a planning proposal, filtering out homeowners. We can help you understand the patterns of thoughts based on whatever segment you\'re interested in examining.'
#   video: 'analytics'
#  }

#  {
#   id: 'translation'    
#   label: 'Multilingual forums & Google Translate'
#   html: 'We offer interface translations in a number of languages, and can do translations to other languages with help. Furthermore, for multi-lingual websites, we offer Google Translate integration.'
#   img: asset('product_page/translation.gif')
#  }
#  {
#   id: 'moderation'    
#   label: 'Content Moderation'
#   html: 'You can choose to review content before it is publicly posted, or just enable moderation for review after posting. The moderation interface enables you to directly contact the author if you wish to ask them to revise a statement that violates community standards. Note that moderation is rarely burdonsome – even for contentious issues, Consider.it tends to foster civil interactions.'
#   #img: asset('product_page/moderation.png')
#  }
#  {
#   id: 'data_export'    
#   label: 'Data export'
#   html: 'Export your forum data into CSV format. We can work with you if you have other data requirements.'
#   img: ''
#  }
# ]  




styles += """
  [data-widget="Research"] {
    max-width: 800px;
    margin: 0px auto 0 auto;
  }

  [data-widget="Research"] .intro {
    margin-bottom: 64px;
  }

  @media (max-width: 414px) {
    [data-widget="Research"] {
      display: none;
    }
  }


"""

Research = ReactiveComponent
  displayName:'Research'

  render: -> 

    authors = (author_list) -> 

      UL 
        style:
          display: 'inline'
          position: 'relative'
          left: 20
          top: 5

        for author,idx in author_list
          LI 
            key: idx
            style: 
              display: 'inline-block'
              listStyle: 'none'
              zIndex: 10 - idx
              position: 'absolute'
              left: 40 * idx
              top: 4 #* idx

            Avatar
              key: "/user/#{author}"
              user: "/user/#{author}"
              img_size: 'large'
              alt: fetch("/user/#{author}").name
              style: 
                width: 50
                height: 50


    papers = [
      {
        url: "http://www.sciencedirect.com/science/article/pii/S0747563215003891"
        title: 'Facilitating Personal Deliberation Online: Effects of Two Consider.it Variations'
        venue: 'Computers in Human Behavior, Volume 51, Part A'
        quote: """
          ...<b>working with Consider.it had significant and meaningful effects on 
          participants’ deliberation and deliberative attitudes</b>. The application urged participants 
          to reconsider and often change their original opinion, and the participants generally felt 
          their knowledge and understanding of the subject-matter had changed.
        """
        authors: [324679, 324678]
      },    
      {
        url: "https://homes.cs.washington.edu/~borning/papers/kriplean-cscw2012.pdf"
        title: 'Supporting Reflective Public Thought with Consider.it'
        venue: 'ACM Conference on Computer Supported Cooperative Work'
        quote: """
          …Given the partisan rancor of our political discourse, especially in online web forums, 
          one might expect few people participating in a public [Consider.it] online discussion 
          during a contentious election to acknowledge the importance of factors on both sides 
          of the debate. However, <strong>we found 41.4% of all Consider.it opinions included 
          both a pro and a con</strong>.
          """
        authors: [323666, 324672, 324669, 324670, 324671]
        hide_quote: true
      },          
      {
        url: "https://f.consider.it/papers/jitp.pdf"
        title: 'Facilitating Diverse Political Engagement'
        venue: 'Journal of Information Technology & Politics, Volume 9, Issue 3'
        quote: """
          Citizens rely on group identity cues to direct their political attentions, which 
          can lead to the views of opposing groups being ignored. But many [Consider.it] users 
          did engage with the ideas of users who took stances opposite their own. Over 
          one-third (33.7%) of point-considering stances recognized points written by 
          dissenting others and over half (56.4%) chose to read more about such points. 
          Taken together, these metrics show <b>[Consider.it] users embraced political 
          diversity in terms of both arguments and the stances of other users</b>.
        """      
        authors: [324669, 323666, 324672, 324671, 324670]
        hide_quote: true
      },    
      {
        url: "http://homes.cs.washington.edu/~borning/papers/kriplean-cscw2014.pdf"
        title: 'On-demand Fact-checking in Public Dialogue'
        venue: 'ACM Conference on Computer Supported Cooperative Work'
        authors: [324673, 323666, 324670, 324675, 324674]
      }
    ]

    reveal = => 
      @local.show = !@local.show
      document.activeElement.blur()
      save @local 



    DIV 
      style: 
        padding: '0 24px'
      A name: 'research'

      H2 
        className: 'light_callout' 
        style: 
          marginBottom: 18
          
        "🤓 Academic Research about Consider.it 🤓"

      DIV 
        className: 'intro embedded'
        dangerouslySetInnerHTML: 
          __html:
            """
              <p>Consider.it was invented at the University of Washington as 
                 part of the National Science Foundation funded <b>
                 <a href='https://f.consider.it/papers/dissertation.pdf'>doctoral research</a></b> of 
                 Consider.it founder <a href="https://traviskriplean.com" target="_blank">Travis Kriplean</a>.</p>
              </p>

              <p>
                 Our goal was to create 
                 a method by which large groups of people could civily 
                 deliberate together online and find common ground, even on contentious topics. Our interdisciplinary team 
                 included researchers from Computer Science, Political Communication, and 
                 Human-centered Design.</p>

              <p>Below are some of the peer-reviewed findings about Consider.it.</p>
            """


      UL
        style: 
          listStyle: 'none'
          position: 'relative'
          margin: '20px 0px 0px 0px'
          paddingBottom: 40

        for paper, idx in papers
          left = false #idx % 2 == 1
          size = 20
          LI 
            key: paper.title
            style: 
              position: 'relative'
              marginBottom: if paper.quote && !paper.hide_quote then 30 else 90

            DIV 
              style: 
                display: 'inline-block'
                textAlign: 'left'
                #maxWidth: '80%'
              A 
                className: 'monospaced'
                style:  
                  color: '#303030'
                  fontSize: 24
                  fontWeight: 700
                  lineHeight: 1.1
                  textDecoration: 'underline'

                href: paper.url
                target: "_blank"
                paper.title

              DIV 
                style: 
                  fontSize: 16
                  # fontWeight: if browser.high_density_display then 300 else 400
                  paddingTop: 8
                  lineHeight: 1.1

                # "Published in "
                SPAN 
                  style: 
                    fontStyle: 'italic'
                  paper.venue


              DIV 
                style: 
                  display: 'inline'
                  fontSize: 16
                  position: 'relative'
                  top: 23
                  fontWeight: 300

                'Researchers: '
              
              authors paper.authors

            if paper.quote && !paper.hide_quote
              DIV
                style: 
                  padding: '36px 50px'
                  position: 'relative'
                  backgroundColor: considerit_gray
                  boxShadow: '#b5b5b5 0 1px 1px 0px'
                  borderRadius: 64
                  marginBottom: 40
                  flex: 1 #'1 auto' # '1 1 auto'
                  marginLeft: 80
                  marginTop: 70
                  maxWidth: 600
                  right: 0
                  display: 'inline-block'

                DIV
                  style: 
                    transform:  "rotate(180deg) scale(-1,-1)"

                    position: 'absolute'
                    left: 56
                    top: -30
                    zIndex: 2

                  Bubblemouth 
                    apex_xfrac: 0
                    width: 30
                    height: 30
                    fill: considerit_gray
                    stroke: 'transparent'
                    stroke_width: 0
                    box_shadow:   
                      dx: -3 
                      dy: 0
                      stdDeviation: 2
                      opacity: .1

                DIV
                  className: 'embedded'
                  style: 
                    fontSize: 16

                  DIV dangerouslySetInnerHTML: {__html: paper.quote}
      
      # BUTTON 
      #   style: 
      #     border: 'none'
      #     backgroundColor: '#eee'
      #     #textDecoration: 'underline'
      #     fontSize: 22
      #     fontWeight: 600
      #     padding: '12px 24px'
      #     margin: '12px auto'
      #     color: '#303030'
      #     display: 'block'
      #     width: '100%'
      #   onClick: reveal
      #   onKeyPress: (e) =>
      #     if e.which == 32 || e.which == 13
      #       reveal()
      #       e.stopPropagation()
      #       e.preventDefault()


      #   "#{if @local.show then 'Hide' else 'Show'} research findings about Consider.it"



styles += """
  [data-widget="CompareToOtherTools"] {
    margin-top: 140px;
    margin-bottom: 80px;
  }

  @media (max-width: 900px) {
    [data-widget="CompareToOtherTools"] {
      display: none;
    }
  }

  [data-widget="CompareToOtherTools"] .bold_callout {
    margin-bottom: 20px;
  }
  [data-widget="CompareToOtherTools"] .intro {
    margin: 0px auto 36px auto;
    max-width: 800px;
    text-align: center;

  }


  [data-widget="CompareToOtherTools"] h3 {
    font-size: 36px;
    text-align: center;
    padding-top: 48px;
    padding-bottom: 48px;
    color: inherit;
  }


  [data-widget="CompareToOtherTools"] .wrapper {
    background: rgb(255,255,255);
    transition: background 1s;
    padding: 0 48px 68px 48px;
    color: white;
    position: relative;

  }

  [data-widget="CompareToOtherTools"] .side-by-side {
    display: flex;
    justify-content: center;
    align-items: baseline; 
  }



  [data-widget="CompareToOtherTools"] .col {

  }

  [data-widget="CompareToOtherTools"] .middle {
    flex-grow: 0;
    width: 96px;
    text-align: center;
    font-size: 26px;
    color: black;
  }


  [data-widget="CompareToOtherTools"] .considerit-col > h3 {
    color: black;
    margin-bottom: 22px;
  }

  [data-widget="CompareToOtherTools"] .other-col > h3 {
    color: black;

  }


  [data-widget="CompareToOtherTools"] .recommendation {
    max-width: 800px;
    margin: auto;
    margin-top: 48px;
  }

  [data-widget="CompareToOtherTools"] .recommendation h3 {
    text-align: left;
    color: white;

  }

  [data-widget="CompareToOtherTools"] .recommendation p {
    max-width: 730px;
    margin-bottom: 18px;
  }

  [data-widget="CompareToOtherTools"] .attributes {
    margin-top: 38px;
  }

  [data-widget="CompareToOtherTools"] .attribute {
    margin-top: 28px;
    font-size: 19px;
    display: flex;
  }

  [data-widget="CompareToOtherTools"] .attribute.won {
    
  }

  [data-widget="CompareToOtherTools"] .attribute.lost {
    opacity: .6;
  } 

  [data-widget="CompareToOtherTools"] .attribute svg {
    flex-shrink: 0;
    flex-grow: 0;
  }
  [data-widget="CompareToOtherTools"] .attribute > span {
    max-width: 500px;
    display: inline-block;
  }

  [data-widget="CompareToOtherTools"] .other-col .attribute svg {
    margin-left: -36px;
  }

  [data-widget="CompareToOtherTools"] .other-col .attribute.won > span{
    padding-left: 8px;
  }

  @media all and (max-width: 1100px) {
    [data-widget="CompareToOtherTools"] .other-col .attribute.won > span{
      padding-left: 0px;
    }
  }


  [data-widget="CompareToOtherTools"] .considerit-col .attribute {
    text-align: right;
    justify-content: right;

  }

  [data-widget="CompareToOtherTools"] .considerit-col .attribute svg {
    margin-right: -36px;
  }

  [data-widget="CompareToOtherTools"] .considerit-col .attribute.won > span{
    padding-right: 8px;
  }
      


"""

CompareToOtherTools = ReactiveComponent 
  displayName: 'CompareToOtherTools'
  render: -> 
    @local.current_comparison ?= 'survey'


    comparison = comparisons[@local.current_comparison] 

    DIV null,
      A name: 'comparison_guide'
      H2 
        className: 'light_callout' 
          
        "Is Consider.it the right tool for you?"

      DIV 
        className: 'intro'

        """
        Use this comparison guide to help figure out which tool suits your needs. 
        """


      DIV 
        key: 'wrapper'
        className: 'wrapper'
        style: 
          background: comparison.background


        DIV
          dangerouslySetInnerHTML: __html: """
            <style>
              .custom-shape-divider-bottom-1649525836 {
                  position: absolute;
                  bottom: 0;
                  left: 0;
                  width: 100%;
                  overflow: hidden;
                  line-height: 0;
              }

              .custom-shape-divider-bottom-1649525836 svg {
                  position: relative;
                  display: block;
                  width: calc(100% + 1.3px);
                  height: 53px;
              }

              .custom-shape-divider-bottom-1649525836 .shape-fill {
                  fill: #FFFFFF;
              }
          </style>
          <div class="custom-shape-divider-bottom-1649525836">
              <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                  <path d="M598.97 114.72L0 0 0 120 1200 120 1200 0 598.97 114.72z" class="shape-fill"></path>
              </svg>
          </div>
          """     


        DIV 
          className: 'side-by-side'

          DIV 
            className: 'considerit-col col'

            H3 null, 
              'Consider.it'

            Webframe
              browser_loc: 'https://livingvotersguide.consider.it/legalize'
              width: "100%"

              DIV 
                style: 
                  width: '100%'
                  margin: 'auto'
                  position: 'relative'

                IMG
                  alt: "Consider.it shows what people think (on a spectrum) and why (using pros and cons)"
                  loading: "lazy"
                  src: asset('product_page/considerit-comparison.png')
                  style: 
                    aspectRatio: '580/340'
                    width: '100%'
                    maxWidth: 582
                    paddingTop: 10
                    display: 'block'


            DIV 
              className: 'attributes'

              for attribute in comparison.attributes
                DIV
                  key: attribute.other
                  className: "attribute #{if !attribute.wins && attribute.wins != 'both' then 'lost' else 'won'}"


                  SPAN null,
                    attribute.considerit

                  if attribute.wins && WINDOW_WIDTH() > 1100
                    checkmark 28, 'white'


          DIV 
            className: 'middle col'

            'vs'








          DIV 
            className: 'other-col col'

            H3 null, 

              DIV 
                style: 
                  position: 'relative'
                  textAlign: 'center'

                SELECT 
                  className: 'unstyled'
                  style: 
                    fontSize: 24
                    padding: '28px 40px'
                    fontWeight: 400
                    backgroundSize: '24px 20px'
                    backgroundColor: 'white'
                    border: '1px solid #979797'
                    borderRadius: 32
                  value: @local.current_comparison
                  onChange: (e) => 
                    @local.current_comparison = e.target.value 
                    save @local
                    document.activeElement.blur()

                  for k,v of comparisons
                    OPTION 
                      key: k
                      value: k
                      style: {}

                      v.name


            Webframe
              browser_loc: comparison.browser_loc 
              width: "100%"

              DIV 
                style: 
                  width: '100%'
                  margin: 'auto'
                  position: 'relative'

                IMG
                  alt: comparison.alt
                  loading: "lazy"                
                  src: comparison.img
                  style: 
                    aspectRatio: '580/340'
                    width: '100%'
                    paddingTop: 10
                    display: 'block'
                    maxWidth: 582

            DIV 
              className: 'attributes'

              for attribute in comparison.attributes
                DIV
                  key: attribute.other
                  className: "attribute #{if attribute.wins && attribute.wins != 'both' then 'lost' else 'won'}"

                  if (!attribute.wins || attribute.wins == 'both') && WINDOW_WIDTH() > 1100
                    checkmark 28, 'white'

                  SPAN null,
                    attribute.other





        DIV 
          className: 'recommendation'


          comparison.recommendation?()





comparisons =
  webforum:
    name: 'Message Boards'
    alt: "Message boards show a post-reply structure."
    browser_loc: 'https://reddit.com/r/politics'
    img: asset('product_page/comparison-messageboard.png')
    background: "linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 300px, rgba(69,78,167,1) 300px, #2d3588 100%)"
    recommendation: -> [
        H3 
          key: 'h3'
          """
          Recommendation: Use a standard web forum if unstructured conversation and individual 
          expression is most important.
          """

        P 
          key: 'p'
          "If so, check out the well-designed "

          A
            key: 'a' 
            href: "https://discourse.org"
            target: "_blank"
            'Discourse' 
          
          " web forum product. " 

          A 
            key: 'a2'
            href: "https://loomio.com"
            target: "_blank"
            'Loomio' 
          
          " is another high quality forum technology with additional functionality for decision making in small groups." 
      ]

    attributes: [
      {
        considerit: 'The interface is novel.'
        other: 'A familiar interface for participants.'
        wins: false
      }

      {
        considerit: 'Host can set and maintain focus.'
        other: 'Supports flexible unstructured discussion.'
        wins: 'both'
      }

      {
        considerit: 'Stays organized and understandable even if hundreds participate.'
        other: 'Gets more overwhelming as more people participate.'
        wins: true
      }

      {
        considerit: 'Consider.it encourages civility because personal attacks don’t fit the pro/con format.'
        other: 'Post / reply format magnifies disagreement and can lead to personal attacks.'
        wins: true
      }

      {
        considerit: 'People see their opinion in relation to others. Back-and-forth tangents are hidden by default.'
        other: 'A few loud voices can hijack the discussion. People can feel their voice is lost in the cacophony.'
        wins: true
      }


    ]


  survey:
    name: 'Surveys'
    alt: "Surveys ask pre-determined questions of people, who answer them independently from each other."
    browser_loc: 'https://www.surveymonkey.com/mp/k-12-parent-survey-template'
    img: asset('product_page/comparison-survey.png')
    background: "linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 300px, #734487 300px, #63217f 100%)"
    preamble: """
      Consider.it is like a hybrid of a survey and a focus group: you get quantitative data 
      like a survey and rich qualitative data like a focus group. Unlike either, Consider.it 
      organizes the quantitative and qualititative data together, so you can make sense of it.
      """
    recommendation: -> [
        H3 
          key: 'h3'
          """
          Recommendation: Use a survey if it is most important for participants to not influence each other.
          """

        # P null,
        #   "If so, check out the well-designed "

        #   A 
        #     href: "https://discourse.org"
        #     target: "_blank"
        #     'Discourse' 
          
        #   " web forum product. " 

        #   A 
        #     href: "https://loomio.com"
        #     target: "_blank"
        #     'Loomio' 
          
        #   " is another high quality forum technology with additional functionality for decision making in small groups." 
      ]

    attributes: [
      {
        considerit: 'The interface is novel.'
        other: 'A familiar interface for participants.'
        wins: false
      }

      {
        considerit: 'Easy to collect demographic-style information, and use it to analyze opinions.'
        other: 'Easy to collect demographic-style information, and visualize it.'
        wins: 'both'
      }

      {
        considerit: 'Opens up a dialogue. Your community can see sticking points and common ground.'
        other: 'People respond independently. They don’t influence or learn from each other.'
        wins: 'both'
      }

      {
        considerit: 'Visualizes what your stakeholders think and why, linked together in an interactive summary.'
        other: 'Open-ended questions are expensive to review, and may require follow-up with stakeholders to validate.'
        wins: true
      }


      {
        considerit: 'Unanticipated ideas and rationale can emerge and gain traction, illuminating community sentiment.'
        other: 'Response categories are set in advance. Learning is limited by the foresight of the survey authors.'
        wins: true
      }


    ]










/** WEBPACK FOOTER **
 ** ../wwwconsiderit/@client/product_page/tour.coffee
 **/